<template>
    <div class="topUpsPage" ref="cashierPage">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="content mbot20 rechargeAmountBox">
            <van-cell-group>
                <van-cell>
                    <div class="rechargeAmount f32">
                        <span class="rechargeAmountIcon">¥</span>
                        <van-field
                        v-model="inputMoney"
                        type="number"
                        @input="oninput"
                        placeholder="请输入充值金额" />
                    </div>
                </van-cell>
                <van-cell>
                    <div class="col8E8E93">
                        可用余额：{{ !showType ? cashierdesk.balance : cashierdesk.walletBalance }}元
                    </div>
                </van-cell>
            </van-cell-group>
        </div>
        <ApplyRadio
        :checkedValue.sync="checkedValue"
        :showBalance="showBalance"
        :showBankList="false"
        :showType='showType'
        :balance="cashierdesk.balance"
        :bankCardsList="cashierdesk.bankCardsList"
        :isApproveData='isApproveData'
        @binkCard="goaddBank"
        >
        </ApplyRadio>
        <div class="bgFFFFFF transferBox" v-if="!showType">
            <img src="../../../../assets/img/b2b/a2.png" alt="未加载成功" class="imgIcon">
            <div class="text f32">银行转账</div>
            <div class="goTransferBtn" @click="goTransferAccount">
                提供转账账户
            </div>
        </div>
        <div class="burse">
            <div class="server" v-if="showType">
                <van-checkbox v-model="checked" shape="square" label-disabled>
                    <span @click="onServer">同意协议</span>
                </van-checkbox>
            </div>
            <div class="buttom bgFF7A45 f32" :class="{'notClickable': showType && !checked}" @click="onPayMoney">充值{{ actualPayment.total | NumFormat }}</div>
        </div>
        <div class="burse mbt48">
            <div class="explain f28 col666" @click="arrivalExplain">到账说明</div>
        </div>
        <van-popup
        v-model="showPopup"
        position="bottom"
        >
            <van-picker
            show-toolbar
            :title="pickerTitle"
            :columns="columns"
            @cancel="onCancel"
            @confirm="onConfirm">
            </van-picker>
        </van-popup>
        <van-dialog
        v-model="showDialog"
        :title="dialogTitle"
        show-cancel-button
        :closeOnClickOverlay="false"
        confirm-button-color="#FF7A45"
        cancel-button-color="#666666"
        :before-close="closeDialog"
        >
            <div class="dialogBox">
                <div class="diologText mbot32">验证码已经发{{ dialogPhone | phoneHide }}</div>
                <div class="dialogInput">
                    <!-- <input input type="tel" maxlength="6" class="dialogCode f32 col000" placeholder="请输入验证码" v-model="smsCode"> -->
                    <van-field v-model="smsCode" placeholder="请输入验证码" class="dialogCode f32 col000" type="tel" maxlength="6" />
                    <div class="codeBtn countdown" v-if="showCount">{{count}}s</div>
                    <div class="codeBtn getCodeCount" v-else @click="getCodeAgin">重新获取</div>
                </div>
            </div>
        </van-dialog>
        <van-dialog
        v-model="showResultDialog"
        message="支付是否已经完成"
        show-cancel-button
        :closeOnClickOverlay="false"
        confirm-button-text="尚未完成"
        confirm-button-color="#FF7A45"
        cancel-button-text="支付完成"
        cancel-button-color="#666666"
        :before-close="closeResultDialog"
        >
        </van-dialog>
        <PayCode :show.sync="show" @onPass='onPass' />
    </div>
</template>

<script>
import Header from '../../../common/header'
import ApplyRadio from '../../../common/applyRadio'
import { Toast, Dialog } from 'vant'
import { mapState, mapGetters, mapActions } from 'vuex'
import { versions } from '../../../common/version'
import { postAppPaymentsSendSms, postAppPaymentsVerifySms, postAppPaymentsPay, getPayStatus, isApprove } from '../../api/api'
import { isPayPass } from '../../api/payment'
import PayCode from '../../payment/component/payCode'

export default {
    name: 'topUps',
    components: {
        Header,
        ApplyRadio,
        PayCode
    },
    data () {
        return {
            title: !this.$route.query.type ? '充值' : '活动预充充值',
            pay: { balanceAmount: 0 },
            showType: !!this.$route.query.type,
            showBalance: !!this.$route.query.type,
            userInfo: '',
            userType: '',
            merchantCode: '',
            inputMoney: null,
            checkedValue: null,
            showPopup: false,
            pickerTitle: '网银支付仅支持部分银行',
            columnsList: [
                {
                    name: '建设银行',
                    limit: 5000,
                    bankId: '105'
                },
                {
                    name: '中国银行',
                    limit: 5000,
                    bankId: '104'
                },
                {
                    name: '农业银行',
                    limit: 10000,
                    bankId: '103'
                },
                {
                    name: '邮储银行',
                    limit: 50000,
                    bankId: '100'
                },
                {
                    name: '平安银行',
                    limit: 5000,
                    bankId: '307'
                },
                {
                    name: '兴业银行',
                    limit: 5000,
                    bankId: '309'
                },
                {
                    name: '浦发银行',
                    limit: 50000,
                    bankId: '310'
                }
            ],
            checkedPicker: {
                name: '',
                limit: 0,
                bankId: ''
            },
            show: false,
            payNo: '',
            authCode: '',
            showDialog: false,
            dialogTitle: '',
            dialogPhone: '12345678910',
            showCount: true,
            count: 60,
            smsCode: '',
            countInterver: null,
            showResultDialog: false,
            isApproveData: {},
            checked: true
        }
    },
    computed: {
        ...mapState({
            getRealut: state => state.b2b.walletState
        }),
        ...mapGetters(['cashierdesk']),
        payMoney: function () {
            return Number(this.inputMoney)
        },
        actualPayment: function () {
            return {
                total: this.payMoney,
                serviceCharge: 0
            }
        },
        columns: function () {
            return this.columnsList.map(v => {
                return `<div>${v.name} <span class="col999 f24">单笔限额￥${v.limit}.00</span></div>`
            })
        },
        payReq: function () {
            return {
                // bizType: !this.showType ? 1 : 3,
                // ebankPay: {
                //     bankId: this.checkedPicker.bankId
                // },
                // interestAmount: this.actualPayment.serviceCharge,
                // orderAmount: this.payMoney,
                // orderId: '',
                // orderNo: '',
                // payAmount: this.actualPayment.total,
                // payMethod: this.checkedValue.payMethod,
                // payeeCompanyCode: this.userInfo.companyCode,
                // payerCompanyCode: this.userInfo.companyCode,
                // quickPay: {
                //     bankCardId: this.checkedValue.bankCardId || ''
                // },
                // wxAppletPay: {
                //     subAppID: 'wxf6e85f0b41014cda'
                //     // subOpenID: 'wxb24533essfssd'
                // }
                orderId: '',
                childOrders: [],
                payerCompanyCode: this.userInfo.companyCode,
                payeeCompanyCode: this.userInfo.belongMerchantCode,
                payMethod: this.checkedValue.payMethod,
                payAmount: this.actualPayment.total,
                orderAmount: this.payMoney, // 订单总金额或者充值总金额
                bizType: !this.showType ? 1 : 3,
                quickPay: {
                    bankCardId: this.checkedValue.bankCardId || ''
                },
                wxAppletPay: {
                    subAppID: 'wxf6e85f0b41014cda'
                },
                ebankPay: {
                    bankId: this.checkedPicker.bankId
                }
            }
        }
    },
    methods: {
        ...mapActions(['setBuried', 'getCashierdeskAct']),
        // 这边先保留4位小数是解决js除法的15位小数问题，然后再保留2位小数并向上取整
        fixed2CeilNum (num) {
            return Math.ceil((num * 100).toFixed(2)) / 100 // 2020.3.6更新算法
            // return Math.ceil(num.toFixed(4) * 100) / 100
        },
        fixed2Num (num) {
            return num.toFixed(2) * 1
        },
        onBack () {
            this.$router.go(-1)
        },
        goTransferAccount () {
            this.$router.replace(
                {
                    path: '/b2b/wallet/transferAccount'
                }
            )
        },
        onServer () {
            this.$router.push({ path: '/b2b/server/precharge' })
        },
        // TODO 这里不直接赋值paymoney是因为数字类型无法输入10.01这种数，不知道为什么
        oninput (value) {
            // const reg = /^(-)*(\d+)\.(\d\d).*$/;
            // this.inputMoney = Number(value.replace(reg, "$1$2.$3"))
            this.inputMoney = (value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
        },
        goaddBank () {
            localStorage.setItem('addBankBack', this.$router.history.current.fullPath)
            this.$router.push(
                {
                    path: '/b2b/order/addBank',
                    query: {
                        userType: this.userType,
                        bindSource: 4
                    }
                }
            )
        },
        onConfirm (value, index) {
            this.checkedPicker = this.columnsList[index]
            this.showPopup = false
            this.thirdPayAsync()
        },
        onCancel () {
            this.showPopup = false
        },
        onPayMoney () {
            // this.buryPoint(69)
            if (!this.payMoney) {
                this.$toast('请输入充值金额')
                return
            }
            // 预发布环境注释100元限制
            // if (this.payMoney < 100) {
            //     this.$toast('最低充值金额100元')
            //     return
            // }
            if (!this.checkedValue) {
                this.$toast('请选择支付方式')
                return
            }
            if (this.showType && !this.checked) {
                this.$toast('请勾选协议')
                return
            }
            if (this.checkedValue.payMethod === 20) {
                this.inputCode()
            } else if (this.checkedValue.payMethod === 30) {
                this.showPopup = true
            } else if (this.checkedValue.payMethod === 10 || this.checkedValue.payMethod === 11) {
                if (this.checkedValue.payMethod === 10 && (this.actualPayment.total > this.cashierdesk.balance)) {
                    this.$toast('充值金额大于钱包余额')
                    return
                }
                this.payAsync()
            } else {
                this.thirdPayAsync()
            }
        },
        /**
         * @description: 发请求，弹出对话框进行验证码输入
         * @param {type} null
         * @return: void
         * 具体的逻辑可能需要在确认
         */
        async inputCode () {
            // 这里执行获取验证码的接口
            const { data } = await postAppPaymentsSendSms(this.checkedValue.bankCardId)
            this.dialogPhone = data.toString()
            clearInterval(this.countInterver)
            this.countInterver = null
            this.showDialog = true
            this.showCount = true
            this.smsCode = ''
            this.count = 60
            this.countInterver = setInterval(() => {
                if (this.count > 0) {
                    this.count--
                } else {
                    this.showCount = false
                    clearInterval(this.countInterver)
                    this.countInterver = null
                }
            }, 1000)
        },
        // 再次获取验证码
        async getCodeAgin () {
            // 这里执行获取验证码的接口
            const { data } = await postAppPaymentsSendSms(this.checkedValue.bankCardId)
            this.dialogPhone = data.toString()
            this.smsCode = ''
            this.showCount = true
            this.count = 60
            this.countInterver = setInterval(() => {
                if (this.count > 0) {
                    this.count--
                } else {
                    this.showCount = false
                    clearInterval(this.countInterver)
                    this.countInterver = null
                }
            }, 1000)
        },
        async closeDialog (action, done) {
            if (action === 'cancel') {
                done()
            } else {
                let codeReg = /^\d{6}$/
                if (!codeReg.test(this.smsCode)) {
                    this.$toast('请正确输入6位验证码')
                    done(false)
                } else {
                    // 这里验证码验证的接口
                    const { data } = await postAppPaymentsVerifySms({
                        code: this.smsCode,
                        phoneNumber: this.dialogPhone
                    }).catch(() => {
                        done(false)
                    })
                    if (data === 0) {
                        done()
                        this.payAsync()
                    } else {
                        done(false)
                    }
                }
            }
        },
        async closeResultDialog (action, done) {
            if (action === 'cancel') {
                const { data: { status } } = await getPayStatus({
                    payNo: this.payNo
                }).catch(() => {
                    done(false)
                })
                this.$router.replace({ path: '/b2b/wallet/topUpsResult', query: { status } })
                done()
            } else {
                const { data: { status } } = await getPayStatus({
                    payNo: this.payNo
                }).catch(() => {
                    done(false)
                })
                this.$router.replace({ path: '/b2b/wallet/topUpsResult', query: { status } })
                done()
            }
        },
        async thirdPayAsync () {
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            const { data: { authCode, payNo } } = await postAppPaymentsPay(this.payReq)
            Toast.clear()
            this.payNo = payNo
            localStorage.setItem('payNo', payNo)
            this.authCode = authCode
            this.showResultDialog = true
            if (this.checkedValue.payMethod === 30) {
                this.$refs.cashierPage.innerHTML = authCode
                document.getElementById('form1').submit()
            } else {
                if (authCode) {
                    if (versions().ios || versions().iPhone || versions().iPad) {
                        window.webkit.messageHandlers.dfxB2b.postMessage({
                            'method': 'CPCNPay',
                            'type': this.checkedValue.payMethod,
                            'authCode': authCode
                        })
                    } else {
                        window.kfxt.CPCNPay(this.checkedValue.payMethod, authCode)
                    }
                }
            }
            // this.$router.push({ path: '/b2b/payment/payResult', query: { status: data.status } })
        },
        async onPass (val) {
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            this.payReq.password = val
            const { data } = await postAppPaymentsPay(this.payReq)
            this.show = false
            Toast.clear()
            this.$router.replace({ path: '/b2b/wallet/topUpsResult', query: { status: data.status } })
        },
        async payAsync () {
            const { data } = await isPayPass({
                companyCode: this.userInfo.companyCode
            })
            if (!data) {
                Dialog.confirm({
                    title: ' ',
                    message: '请先设置钱包支付密码！',
                    confirmButtonText: '去设置',
                    confirmButtonColor: '#FF7A45',
                    cancelButtonColor: '#666666'
                }).then(() => {
                    this.$router.push({ path: '/b2b/payCode/setPayCode' })
                })
            } else {
                this.show = true
            }
        },
        arrivalExplain () {
            Dialog.alert({
                title: '到账说明',
                messageAlign: 'left',
                message: '到账说明：\n1、第三方充值是实时到账，最长不超过24小时。\n2、大额转账充值（≥￥5万）时，具体因转账银行不同，转账时间有差异。详情如下：\n转账金额＜5万人民币，实时到账，最长不超过24小时。\n转账金额≥5万人民币，工作日时间（10:00-16:00）转账，工作日到账。\n如遇到非工作时间或者节假日，到账时间顺延。'
            }).then(() => {
                // on close
            })
        },
        async getPayCenter () {
            await this.getCashierdeskAct({
                companyCode: this.userInfo.companyCode
            })
        },
        buryPoint (event) {
            this.setBuried({ event: event })
        },
        async getApprove () {
            const { data } = await isApprove({
                companyCode: this.userInfo.companyCode
            })
            this.isApproveData = data
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.userType = JSON.parse(localStorage.getItem('userType')) || this.$route.query.userType
        this.getPayCenter()
        this.getApprove()
        window.CPCNPayResult = (code, error) => {
            // console.log(code)
        }
    }
}
</script>
<style lang="scss" scoped>
    .topUpsPage {
        height: 100%;
        .content {
            font-size: 32px;
            color: #000000;
            padding-left: 32px;
            background: #ffffff;
            &.mbot48 {
                margin-bottom: 48px;
            }
        }
        .rechargeAmountBox {
            .rechargeAmount {
                display: flex;
                align-items: center;
                .rechargeAmountIcon {
                    font-size: 48px;
                    font-weight: bold;
                    margin-right: 16px;
                }
            }
            /deep/ .van-cell{
                padding: 24px 0;
                font-size: 100%;
            }
        }
        .areaTitle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px 32px;
            border-bottom: 1PX solid #EDEDF0;
            .areaButton {
                padding: 10px;
                border: 1PX solid #EDEDF0;
            }
        }
        .transferBox {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 32px;
            .imgIcon {
                width: 80px;
                height: 80px;
                margin-right: 24px;
            }
            .text {
                flex: 1;
                display: inline-block;
                line-height: 80px;
                font-weight: bold;
                margin-right: 16px;
            }
            .goTransferBtn {
                width: 208px;
                height: 64px;
                line-height: 64px;
                text-align: center;
                color: #FF7A45;
                border: 2px solid #FF7A45;
                border-radius: 32px;
            }
        }
        .burse{
            text-align: center;
            padding: 0 32px;
            margin-top: 48px;
            .buttom{
                height: 96px;
                line-height: 96px;
                border-radius: 96px;
                border: 2px solid #FF7A45;
                margin-bottom: 40px;
            }
            &.mbt48 {
                margin-bottom: 48px;
            }
        }
        /deep/ .van-cell__value {
            line-height: initial;
            height: auto;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: initial;
            white-space: normal;
            word-break: break-all;
            color: #676767;
        }
        /deep/ .van-picker__toolbar {
            height: 88px;
            line-height: 88px;
        }

        /deep/ .van-picker__title {
            font-size: 36px;
            max-width: 80%;
            line-height: normal;
        }

        /deep/ .van-picker__cancel, /deep/ .van-picker__confirm {
            font-size: 30px;
            padding:  0 24px;
        }

        /deep/ .van-picker-column__item {
            font-size: 36px;
        }
        .dialogBox {
            padding: 48px;
            .dialogInput {
                display: flex;
                .dialogCode {
                    flex: 1;
                    height: 80px;
                    padding: 18px 24px;
                    border: #EDEDF0 1px solid;
                }
                .codeBtn {
                    width: 196px;
                    height: 80px;
                    font-size: 26px;
                    text-align: center;
                    line-height: 80px;
                    &.countdown {
                        color: #C7C7C7;
                        background-color: #EAEAEA;
                    }
                    &.getCodeCount {
                        color: #ffffff;
                        background-color: #FF7A45;
                    }
                }
            }
        }
    }
    .notClickable{
        background: #eaeaea !important;
        color: #c7c7c7 !important;
        border: none !important;
    }
    .van-checkbox {
        padding: 24px 0;
    }
    /deep/ .van-checkbox__label {
        line-height: inherit;
        font-size: 24px;
        margin-left: 20px;
        span{
            text-decoration: underline;
        }
    }
    /deep/ .van-checkbox__icon {
        font-size: 24px;
    }
    /deep/ .van-checkbox__icon .van-icon{
        font-size: 24px;
    }
</style>
